export class StartViewController {

    constructor ($log, $state, UserSessionService, PhotoUploaderService, ProjectBrowserService) {
        'ngInject';

        this.$log = $log;
        this.$state = $state;
        this.userSessionService = UserSessionService;
        this.photoUploaderService = PhotoUploaderService;
        this.projectBrowserService = ProjectBrowserService;

        this.$log.debug('StartViewController::constructor');
    }

    $onInit() {
        this.$log.debug('StartViewController::$onInit');
    }

    uploadPhoto() {
        this.photoUploaderService.open().then((response) => {
            this.userSessionService.setBaseImage({
                file: response.file,
                url: response.url,
                width: response.width,
                height: response.height
            });
            this.$state.go('draw');
        });
    }

    browseProjects() {
        this.projectBrowserService.open().then((response) => {

            this.userSessionService.setBaseImage({
                file: response.image,
                url: response.image_url,
                width: response.width,
                height: response.height
            });

            response.doors_json.forEach((door) => {
                this.userSessionService.addDoor({
                    type: door.type,
                    points: door.points
                });
            });

            this.$state.go('design');
        });
    }

}



// WEBPACK FOOTER //
// ./src/js/views/start-view/start-view.controller.js